import { createAction, props } from '@ngrx/store';
import { Format, TimeAlignment } from 'estensa-module';
import { CaliperMode, PaperRate } from '../../ecg-viewer-module/models/enums';
import { CaliperMessage, GuidedComparisonMessageParam, ICustomCommandState } from '../ecg-viewer-state.models';
/* not used */
export const TOOLBAR_VISIBLE = '[ECGViewer] Toolbar Visible';
export const toolbarVisibleMessage = createAction(TOOLBAR_VISIBLE, props<{ toolbarVisible: boolean }>());

/* not used */
export const PRINT_AS_DISPLAYED = '[ECGViewer] Print As Displayed';
export const printAsDisplayedMessage = createAction(PRINT_AS_DISPLAYED, props<{ printAsDisplayed: boolean }>());

export const CULTURE = '[ECGViewer] Culture';
export const cultureMessage = createAction(CULTURE, props<{ culture: number }>());

export const FIDUCIAL_POINTS_VISIBLE = '[ECGViewer] Fiducial Points Visible';
export const fiducialPointsVisibleMessage = createAction(
    FIDUCIAL_POINTS_VISIBLE,
    props<{ fiducialPointsVisible: boolean }>(),
);

export const HORIZONTAL_STUDY_SPACING = '[EcgViewer] HorizontalStudySpacing';
export const horizontalStudySpacingMessage = createAction(
    HORIZONTAL_STUDY_SPACING,
    props<{ horizontalStudySpacing: number }>(),
);

export const STUDY_SPACING = '[EcgViewer] StudySpacing';
export const studySpacingMessage = createAction(STUDY_SPACING, props<{ studySpacing: number }>());

export const GUIDED_COMPARISON = '[EcgViewer] GuidedComparison';
export const guidedComparisonMessage = createAction(
    GUIDED_COMPARISON,
    props<{ guidedComparison: GuidedComparisonMessageParam }>(),
);

export const TRACE_SPACING = '[EcgViewer] TraceSpacing';
export const traceSpacingMessage = createAction(TRACE_SPACING, props<{ traceSpacing: number }>());

export const PAPER_RATE = '[EcgViewer] PaperRate';
export const paperRateMessage = createAction(PAPER_RATE, props<{ paperRate: PaperRate }>());

export const PAPER_OPACITY = '[EcgViewer] PaperOpacity';
export const paperOpacityMessage = createAction(PAPER_OPACITY, props<{ paperOpacity: number }>());

export const TIME_ALIGNMENT = '[EcgViewer] TimeAlignment';
export const timeAlignmentMessage = createAction(TIME_ALIGNMENT, props<{ timeAlignment: TimeAlignment }>());

export const FORMAT = '[EcgViewer] Format';
export const formatMessage = createAction(FORMAT, props<{ format: Format }>());

export const FIT = '[EcgViewer] Fit';
export const fitMessage = createAction(FIT);

export const ZOOM_FACTOR = '[EcgViewer] ZoomFactor';
export const zoomFactorMessage = createAction(ZOOM_FACTOR, props<{ zoomFactor: number }>());

export const BASELINE = '[EcgViewer] Baseline';
export const baselineMessage = createAction(BASELINE, props<{ isFitBaseline: boolean }>());

export const ARRANGEMENT = '[EcgViewer] Arrangement';
export const arrangementMessage = createAction(ARRANGEMENT, props<{ arrangement: number }>());

export const MEASURELIST_CHANGED = '[EcgViewer] MeasureListChanged';
export const measureListChangedMessage = createAction(MEASURELIST_CHANGED);

export const CALIPER_MODE = '[EcgViewer] CaliperMode';
export const caliperModeMessage = createAction(CALIPER_MODE, props<{ caliperMode: CaliperMode }>());

export const CALIPER_ADD = '[EcgViewer] CaliperAdd';
export const caliperAddMessage = createAction(CALIPER_ADD, props<{ caliperMessage: CaliperMessage }>());

export const CALIPER_REMOVE = '[EcgViewer] CaliperRemove';
export const caliperRemoveMessage = createAction(CALIPER_REMOVE, props<{ caliperMessage: CaliperMessage }>());

export const CALIPER_MODIFY = '[EcgViewer] CaliperModify';
export const caliperModifyMessage = createAction(CALIPER_MODIFY, props<{ caliperMessage: CaliperMessage }>());

export const CUSTOM_COMMAND = '[EcgViewer] CustomCommand';
export const customCommandMessage = createAction(CUSTOM_COMMAND, props<{ customCommand: ICustomCommandState }>());

export const VISUAL_COMPARISON = '[EcgViewer] VisualComparison';
export const visualComparisonMessage = createAction(VISUAL_COMPARISON, props<{ visualComparison: boolean }>());

//USED INTO ANOTHER PROJECT se modules cardiology ecgreportindetails
export const DETAILS_VISIBLE = '[ECGViewer] Details Visible';
export const detailsVisibleMessage = createAction(DETAILS_VISIBLE, props<{ detailsVisible: boolean }>());

export const SUMMARY_VISIBLE = '[ECGViewer] Summary Visible';
export const summaryVisibleMessage = createAction(SUMMARY_VISIBLE, props<{ summaryVisible: boolean }>());
